import styled, { StyledComponent } from '@emotion/styled';
import { Theme, Spinner } from '@prometheus/components';

export const LayoutSpinner: StyledComponent<any> = styled(Spinner)`
  margin-top: 20%;
`;
